import { render, staticRenderFns } from "./MobileFooter.vue?vue&type=template&id=0bf5b3de&scoped=true"
import script from "./MobileFooter.vue?vue&type=script&lang=js"
export * from "./MobileFooter.vue?vue&type=script&lang=js"
import style0 from "./MobileFooter.vue?vue&type=style&index=0&id=0bf5b3de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf5b3de",
  null
  
)

export default component.exports